export default "__VITE_ASSET__Drc5r8_a__"